import React from 'react';

/**
 * This is just a temporary icon to be replaced with an icon from @atlaskit/icon-lab, currently the icon is not available in @atlaskit/icon-lab.
 */
export const TextSmallIcon = ({ size }: { label?: string; size?: string }) => {
	const dimension = size === 'small' ? 12 : 16;
	return (
		<svg width={dimension} height={dimension} viewBox="0 0 16 16" fill="none" role="presentation">
			<g transform="translate(-1.614, -1.561) scale(0.95)">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M6.8125 4.5H2V3H13V4.5H8.3125V17H6.8125V4.5Z"
					fill="currentcolor"
				/>
				<path
					d="M14.448 17.128C13.7973 17.128 13.2373 17.032 12.768 16.84C12.3093 16.6373 11.9573 16.3493 11.712 15.976C11.4773 15.592 11.36 15.128 11.36 14.584H12.8C12.8 14.9893 12.944 15.3093 13.232 15.544C13.52 15.768 13.9253 15.88 14.448 15.88H15.152C15.6853 15.88 16.096 15.7627 16.384 15.528C16.6827 15.2933 16.832 14.9627 16.832 14.536C16.832 14.152 16.7467 13.8533 16.576 13.64C16.4053 13.4267 16.144 13.2987 15.792 13.256L13.36 12.904C12.7627 12.8187 12.2987 12.5733 11.968 12.168C11.6373 11.752 11.472 11.208 11.472 10.536C11.472 9.768 11.7333 9.16533 12.256 8.728C12.7893 8.29067 13.52 8.072 14.448 8.072H15.152C16.0053 8.072 16.6987 8.28533 17.232 8.712C17.776 9.128 18.0693 9.67733 18.112 10.36H16.656C16.6347 10.0507 16.4853 9.79467 16.208 9.592C15.9413 9.38933 15.5893 9.288 15.152 9.288H14.448C13.9573 9.288 13.5733 9.4 13.296 9.624C13.0187 9.848 12.88 10.152 12.88 10.536C12.88 10.8347 12.9493 11.0747 13.088 11.256C13.2373 11.4373 13.4507 11.5493 13.728 11.592L16 11.912C16.7467 12.0187 17.3067 12.2907 17.68 12.728C18.0533 13.1653 18.24 13.768 18.24 14.536C18.24 15.3573 17.968 15.9973 17.424 16.456C16.8907 16.904 16.1333 17.128 15.152 17.128H14.448Z"
					fill="currentcolor"
				/>
			</g>
		</svg>
	);
};
